import { __, compose, divide, length, map, sum } from "ramda";

export const geometricMean = array =>
    compose(
        Math.exp,
        divide(__, length(array)),
        sum,
        map(Math.log)
    )(array);
